import { UserCoupon } from "shared/models";
import { FortuneTeller } from "shared/types";

const campaignCoupons = [
  {
    name: "電話占いが初回無料！？電話占い3000円分無料クーポン",
    catchCopy:
      "はじめての電話占いで利用できる3000円分無料クーポンがプレゼントされました！",
    description:
      "電話鑑定をご利用された事がないお客様限定で、0円~電話鑑定をお楽しみいただけるクーポンを配布させていただきました。",
  },
  {
    name: "電話占いが1回無料！？電話占い3000円分無料クーポン",
    catchCopy:
      "電話占いで利用できる3000円分無料クーポンがプレゼントされました！",
    description:
      "一部のお客様限定で、0円~電話鑑定をお楽しみいただけるクーポンを配布させていただきました。",
  },
];

const thanksOrderCoupons = [
  {
    name: "鑑定通話終了3時間以内1000円OFFクーポン",
  },
  {
    name: "電話鑑定申込完了3時間以内1000円OFFクーポン",
  },
];

export type CampaignCoupon = UserCoupon & typeof campaignCoupons[number];

export const selectCampaignCoupons = (coupons: UserCoupon[] | undefined) => {
  return coupons
    .map((coupon) => {
      const campaignCoupon = campaignCoupons.find(
        (campaignCoupon) => campaignCoupon.name === coupon.name
      );

      if (campaignCoupon) {
        return {
          ...coupon,
          ...campaignCoupon,
        } as CampaignCoupon;
      }
    })
    .filter(Boolean);
};

export const selectThanksOrderCoupons = (coupons: UserCoupon[] | undefined) => {
  return coupons.filter((coupon) => {
    return thanksOrderCoupons.find(
      (campaignCoupon) => campaignCoupon.name === coupon.name
    );
  });
};

export const selectAvailableCoupons = (
  coupons: UserCoupon[],
  fortuneTeller: FortuneTeller | undefined
) => {
  if (!fortuneTeller) return [];

  const campaignCoupons = selectCampaignCoupons(coupons);

  return campaignCoupons.filter((coupon) => {
    return coupon.couponRestrictionTypes.some((restriction) => {
      const forFortuneTeller = restriction.name === "fortune_teller";
      const isAvailableFortuneTeller =
        restriction.couponRestrictionColumns.some(
          (column) =>
            column.value === fortuneTeller[column.name as keyof FortuneTeller]
        );
      return forFortuneTeller && isAvailableFortuneTeller;
    });
  });
};
